// src/components/PortalAluno/CheckoutDashboard.tsx
// Substituído por placeholder "Em breve" — cursos ainda não disponíveis no portal do aluno

import React from 'react';
import { Sparkles, ShoppingBag, CreditCard, GraduationCap } from 'lucide-react';
import { Link } from 'react-router-dom';

const CheckoutDashboard: React.FC = () => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">

    {/* Ícone */}
    <div className="relative mb-8">
      <div className="absolute inset-0 blur-[32px] rounded-full scale-150"
        style={{ background: 'rgba(212,175,55,0.2)' }}/>
      <img
        src="/icons/course.png"
        alt="Cursos"
        className="relative w-24 h-24 object-contain
          drop-shadow-[0_4px_20px_rgba(212,175,55,0.55)]"
      />
    </div>

    {/* Texto */}
    <h1 className="text-3xl font-black text-gray-900 mb-3 tracking-tight">
      Cursos — Em Breve
    </h1>
    <p className="text-gray-500 max-w-md leading-relaxed mb-8">
      Em breve você poderá explorar e adquirir cursos diretamente pelo portal,
      com pagamento integrado e seus certificados gerados automaticamente.
    </p>

    {/* Cards de funcionalidades */}
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl w-full mb-8">
      {[
        { icon: ShoppingBag,    label: 'Catálogo Completo',   desc: 'Explore cursos homologados pela Federação' },
        { icon: CreditCard,     label: 'Pagamento Integrado', desc: 'Compre com segurança e praticidade'        },
        { icon: GraduationCap,  label: 'Certificado Digital', desc: 'Receba seu certificado automaticamente'    },
      ].map(({ icon: Icon, label, desc }) => (
        <div key={label}
          className="bg-white rounded-2xl border border-gray-100
            shadow-[0_1px_8px_rgba(0,0,0,0.05)] p-5 text-left">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center mb-3"
            style={{ background: 'rgba(212,175,55,0.12)' }}>
            <Icon className="w-5 h-5 text-amber-600"/>
          </div>
          <p className="text-sm font-semibold text-gray-800 mb-1">{label}</p>
          <p className="text-xs text-gray-400 leading-relaxed">{desc}</p>
        </div>
      ))}
    </div>

    {/* Badge + link para site público */}
    <div className="flex flex-col items-center gap-4">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full
        border border-amber-200 bg-amber-50">
        
        <span className="text-sm font-semibold text-amber-700">Novidade em desenvolvimento</span>
      </div>
      <Link to="/cursos"
        className="text-sm text-amber-600 font-medium hover:text-amber-700 transition-colors underline-offset-4 hover:underline">
        Ver cursos disponíveis no site →
      </Link>
    </div>
  </div>
);

export default CheckoutDashboard;